import { Component } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-hero-section',
  imports: [RouterModule, TranslateModule, NgClass],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss',
  standalone: true,
  host: { id: 'hero-section' },
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('800ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('fadeInRight', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(20px)' }),
        animate('800ms 400ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ])
  ]
})
export class HeroSectionComponent {
  constructor(public translate: TranslateService) {}
}
